<template>
  <div id="orgUploadLogoWindow">
    <el-dialog title="上传企业LOGO" :visible.sync="dialogVisible" width="600px">
      <div class="dialog-body" style="border-top: 1px solid #e5e5e5;">
        <div class="panel-body-row">
          <div class="panel-body-row-left">上传企业LOGO:</div>
          <div class="panel-body-row-right">
            <el-upload
              name="orgLogoFileName"
              ref="upload"
              :auto-upload="false"
              :show-file-list="false"
              :action="postImgUrl"
              :data="postData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :on-error="handleAvatarError"
              :on-change="handleChange"
              list-type="picture"
            >
              <el-button
                slot="trigger"
                class="eb-button-group-btn eb-button-orange eb-button-big"
              >选择文件</el-button>
            </el-upload>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">图片预览：</div>
          <div
            class="panel-body-row-right"
            style="height:300px;width:300px;border:1px solid #ccc;margin-top:10px;display:flex;"
          >
            <img
              id="orgLogoFilePreview"
              :src="imageUrl"
              :data-img="imgData"
              style="margin:auto;max-width:100%;max-height:100%;height: auto;width: auto;"
            >
          </div>
        </div>
      </div>
      <div
        class="dialog-footer eb-button-group"
        slot="footer"
        style="border-top: 1px solid #e5e5e5;"
      >
        <el-button
          :loading="buttonLoading"
          @click="closeMyDialog()"
          class="eb-button-group-btn eb-button-orange eb-button-big"
        >取消</el-button>
        <el-button
          :loading="buttonLoading"
          @click="uploadOrgLogoFile()"
          class="eb-button-group-btn eb-button-orange eb-button-big"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios.js';
import moment from 'moment';
export default {
  name: 'orgUploadLogoWindow',
  props: {
    user: {},
    orgInfo: {}
  },
  data() {
    return {
      dialogVisible: false,
      buttonLoading: false,
      imageUrl: '',
      imgData: false,
      postImgUrl: baseURL + '/api/depart/uploadDepartLogo',
      postData: {
        departId: this.user.orgId,
        channel: 'org-logo'
      },
      fileList: []
    };
  },
  created() {
    eventBus.$on('showOrgUploadLogoWindow', params => {
      let m = moment();
      this.imageUrl = this.orgInfo.departLogo
        ? baseURL + this.orgInfo.departLogo + '?m=' + m
        : baseURL + '/static/img/147x147.png';
      this.dialogVisible = true;
    });
  },
  methods: {
    uploadOrgLogoFile() {
      this.$refs.upload.submit();
      this.dialogVisible = false;
    },
    handleAvatarSuccess(res, file) {
      if (res.returnCode === '01') {
        let m = moment();
        this.orgInfo.departLogo = res.departLogo + '?m=' + m;
        this.$message.success('企业LOGO上传成功');
        eventBus.$emit('refreshOrgInfo', false);
      } else {
        this.$message.error('企业LOGO上传失败');
      }
    },
    beforeAvatarUpload(file) {
      let fileName = file.name;
      const isLt1M = file.size < 999000;
      if (!eval(/.(gif|jpg|jpeg|png)$/.test(fileName))) {
        this.$message.error('上传图片只能是 jpg,jpeg,gif,png 格式!');
        return false;
      }
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      return true;
    },
    handleAvatarError(err, file, fileList) {
      if (err) {
        this.$message.error('文件上传失败');
      }
    },
    handleChange(file, fileList) {
      this.imageUrl = file.url;
      this.imgData = true;
    },
    closeMyDialog() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped lang="less">
.el-dialog__header {
  padding: 2px 20px 10px 10px;
}

.fileinput-button {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.btn-redbtn {
  cursor: pointer;
  display: inline-block;
  height: 33px;
  line-height: 30px;
  width: 126px;
  color: #fb5b3b;
  border: 1px solid #fb5b3b;
  background-color: #fff;
  border-radius: 4px;
  font-size: 14px;
  margin: 0;
  padding: 0;
  text-align: center;
  position: relative;
  font-family: 'Microsoft YaHei';
  box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.4);
  -webkit-box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.4);
  height: 22px;
  width: 88px;
  line-height: 22px;
}

.fileinput-button input {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  opacity: 0;
  -ms-filter: 'alpha(opacity=0)';
  font-size: 200px !important;
  direction: ltr;
  cursor: pointer;
}
</style>
